import { render, staticRenderFns } from "./IndividualDealGeneral.vue?vue&type=template&id=200185e6"
import script from "./IndividualDealGeneral.vue?vue&type=script&lang=js"
export * from "./IndividualDealGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports